import Vue from 'vue';
import Vuex from 'vuex';

import jwt from 'jsonwebtoken';

Vue.use(Vuex);

// // Make Axios play nice with Django CSRF
// axios.defaults.xsrfCookieName = 'csrftoken'
// axios.defaults.xsrfHeaderName = 'X-CSRFToken'

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token'),
  },

  getters: {
    isAuthenticated: state => {
      return state.token && jwt.decode(state.token).exp > Date.now() / 1000;
    },
    user: state => {
      if (state.token) {
        return jwt.decode(state.token);
      }
      return null;
    }
  },

  mutations: {
    setAuthUser(state, token) {
      localStorage.setItem('token', token);
      // state.route.$router.push({name: 'home'});
    },
    removeToken() {
      localStorage.removeItem('token');
    }
  }
})